import React from 'react';
import { useRecoilValue } from 'recoil';
import Balloon from '../balloon/Balloon';
import {
  currentScenarioItemState,
  displayedScenarioItemState,
} from '../../stores/displayedScenarioItemState';

const Thread = () => {
  const items = useRecoilValue(displayedScenarioItemState);
  const currentItem = useRecoilValue(currentScenarioItemState);

  return (
    <div className="thread">
      {items.map(item => (<Balloon key={item.id} item={item} current={item === currentItem} onCommit={() => {
      }}/>))}
    </div>
  );
};

export default Thread;
